import React, { useState } from "react";
import { AiOutlineMinus } from "react-icons/ai";

const InputTag = ({
  label,
  length,
  name,
  defaultValue,
  type,
  multiple,
  required,
  disabled,
}) => {
  const [visibility, setVisibility] = useState(true);

  const handleDelete = () => {
    setVisibility(false);
    // console.log("visi");
  };

  return (
    <div
      key={Math.random()}
      className={visibility ? "flex gap-1 items-end w-full" : "hidden"}
    >
      <div className="w-full">
        <label className="label">
          <span className="text-md font-semibold">
            {multiple && length ? label + " " + length : label}
          </span>
        </label>
        <input
          //name={visibility ? name : ""}
          name={name}
          defaultValue={defaultValue}
          type={type}
          className="input input-bordered w-full z-0"
          required={required}
          disabled={disabled}
          onKeyDown={(e) => {
            e.key === "Enter" && e.preventDefault();
          }}
        />
      </div>
      <div className={!multiple && "hidden"}>
        <button
          type="button"
          onClick={handleDelete}
          className="btn  btn-sm btn-circle"
        >
          <AiOutlineMinus />
        </button>
      </div>
    </div>
  );
};

export default InputTag;
